// Mirrors Backend Sprint 5's ReturnRequest::STATUSES + REASONS + CONDITIONS.
// Single source of truth for label + chip color across the customer-side
// returns UI. Stays in sync with the dashboard's webhookConstants pattern.

export const RETURN_STATUSES = {
    pending:    { color: 'warning', labelEn: 'Pending review', labelAr: 'قيد المراجعة' },
    approved:   { color: 'info',    labelEn: 'Approved',       labelAr: 'مقبول' },
    rejected:   { color: 'error',   labelEn: 'Rejected',       labelAr: 'مرفوض' },
    processing: { color: 'info',    labelEn: 'Processing',     labelAr: 'قيد المعالجة' },
    shipped:    { color: 'info',    labelEn: 'Shipped back',   labelAr: 'تم الشحن' },
    received:   { color: 'info',    labelEn: 'Received',       labelAr: 'تم الاستلام' },
    completed:  { color: 'success', labelEn: 'Completed',      labelAr: 'مكتمل' },
    cancelled:  { color: 'default', labelEn: 'Cancelled',      labelAr: 'ملغي' },
};

// Order of states on the horizontal timeline (linear path the backend
// normally takes; rejected / cancelled are terminal off-path states).
export const STATUS_TIMELINE = ['pending', 'approved', 'shipped', 'received', 'completed'];

export const RETURN_REASONS = [
    { value: 'defective',         labelEn: 'Defective',         labelAr: 'معيب' },
    { value: 'wrong_item',        labelEn: 'Wrong item',        labelAr: 'منتج خاطئ' },
    { value: 'not_as_described',  labelEn: 'Not as described',  labelAr: 'مختلف عن الوصف' },
    { value: 'changed_mind',      labelEn: 'Changed my mind',   labelAr: 'غيّرت رأيي' },
    { value: 'damaged',           labelEn: 'Damaged in transit', labelAr: 'تالف بالشحن' },
    { value: 'other',             labelEn: 'Other',             labelAr: 'سبب آخر' },
];

export const RETURN_CONDITIONS = [
    { value: 'unopened',  labelEn: 'Unopened',  labelAr: 'لم يُفتح' },
    { value: 'opened',    labelEn: 'Opened',    labelAr: 'تم فتحه' },
    { value: 'used',      labelEn: 'Used',      labelAr: 'مُستخدم' },
    { value: 'damaged',   labelEn: 'Damaged',   labelAr: 'تالف' },
    { value: 'defective', labelEn: 'Defective', labelAr: 'معيب' },
];
